import React from 'react';
import ShopCard from '../ShopCard/ShopCard';

export const MY_ZONE_SHOP_TRACKING_LOCATION = 'store-card:';

const MyZoneShopCard = (props) => React.createElement(ShopCard, {
  ...props,
  trackingLocation: MY_ZONE_SHOP_TRACKING_LOCATION,
});

export default MyZoneShopCard;
